import { getLocalUnitPrice } from '..';
import {
  CurrencyISOCode,
  PriceCalculationResponse,
  PricingTier
} from '../../models';

export default function (
  numUnits: number,
  matchingTierIdx: number,
  tiers: PricingTier[],
  currencyISOCode: CurrencyISOCode
): PriceCalculationResponse {
  const matchingTier = tiers[matchingTierIdx];

  if (!matchingTier) {
    throw new Error(`Matching price tier not found for ${numUnits}.`);
  }

  const { prices, unitLimitLower, unitLimitUpper } = matchingTier;
  const totalPrice = getLocalUnitPrice(currencyISOCode, prices.slice());
  const avgPerUnitPrice = totalPrice / numUnits;

  return {
    totalPrice,
    avgPerUnitPrice,
    hasFlatRateFirstTier: true,

    breakdown: [
      {
        unitsInTier: numUnits,
        unitsAvailableInTier: (unitLimitUpper || 0) - numUnits,

        unitLimitLower: unitLimitLower || 1,
        unitLimitUpper: unitLimitUpper || 0,

        totalPriceForTier: totalPrice,
        avgPerUnitPriceForTier: totalPrice / numUnits
      }
    ]
  };
}
